const cssCalcBetweenViewport = (min: number, max: number, type = 'px', minViewport = 320, maxViewport = 2000) => `
    calc(${min}${type} + (${max} - ${min}) * ((100vw - ${minViewport}px) / (${maxViewport} - ${minViewport})))
`;

export default cssCalcBetweenViewport;
